import React, { FC, useState } from 'react';
import { InputText, Icon } from 'components';
import { InputWraper, Button, Table } from 'modules';
import { structure } from './configs';
import _ from 'lodash';

const ElectricBillOrderInfo: FC = () => {
  const [valueCheckbox, setValueCheckbox] = useState<any>([]);

  return (
    <div className='container-fluid'>
      <div className='row electric-bill-order-info__wrapInput'>
        <div className='col-md-4 col-12'>
          <InputWraper
            label='Mã đơn hàng'
            component={InputText}
            inputProps={{
              value: 'Mã đơn hàng',
              name: 'orderCode',
              isReadOnly: true,
              onChange: () => {},
              onTouched: () => {},
            }}
          />
        </div>
        <div className='col-md-4 col-12'>
          <InputWraper
            label='Lượng giao dịch'
            component={InputText}
            inputProps={{
              value: 'Lượng giao dịch',
              name: 'orderCode',
              isReadOnly: true,
              onChange: () => {},
              onTouched: () => {},
            }}
          />
        </div>
        <div className='col-md-4 col-12'>
          <InputWraper
            label='Lượng thành công'
            component={InputText}
            inputProps={{
              value: 'Lượng thành công',
              name: 'orderCode',
              isReadOnly: true,
              onChange: () => {},
              onTouched: () => {},
            }}
          />
        </div>
        <div className='col-md-4 col-12'>
          <InputWraper
            label='Lượng thất bại'
            component={InputText}
            inputProps={{
              value: 'Lượng thất bại',
              name: 'orderCode',
              isReadOnly: true,
              onChange: () => {},
              onTouched: () => {},
            }}
          />
        </div>
        <div className='col-md-4 col-12'>
          <InputWraper
            label='Trạng thái'
            component={InputText}
            inputProps={{
              value: 'Trạng thái',
              name: 'orderCode',
              isReadOnly: true,
              onChange: () => {},
              onTouched: () => {},
            }}
          />
        </div>
      </div>

      <div className='electric-bill-order-info__table'>
        <div className='electric-bill-order-info__header'>
          <div className='electric-bill-order-info__header--right'>
            <Button label='Chọn in hoá đơn' buttonType='info-outline' />
          </div>

          <div className='electric-bill-order-info__header--left'>
            <Icon.Search />
            <InputText
              placeholder='Nhập từ khoá tìm kiếm'
              name='search'
              isReadOnly={false}
              onChange={() => {}}
              onTouched={() => {}}
            />
          </div>
        </div>
        <Table
          addMoreTRTopElectricBillOrderInfo={true}
          hasCheckbox={true}
          onChangeCheckbox={(data) =>
            setValueCheckbox((preState: any) => {
              if (data.value === -1) {
                //data.value === -1 => check all or uncheck all
                if (data?.checked === true) return [data];
                if (data?.checked === false) return [];
              }
              const temp = preState?.filter(
                (item: any) => _.isEqual(item?.value, data?.value) === false,
              );
              if (data?.checked === true) return [...temp, data];
              if (data?.checked === false) return [...temp];
            })
          }
          structure={structure()}
          fetchData={async (params) => {
            return {
              count: 1,
              data: [
                {
                  stt: 1,
                  transactionCode: 'transactionCode',
                  account: 'account',
                  teamLeader: 'teamLeader',
                  serviceType: 'serviceType',
                  customerCode: 'customerCode',
                  customerName: 'customerName',
                  month: 'month',
                  amount: 'amount',
                  payment: 'payment',
                  refund: 'refund',
                  status: 'status',
                  time: 'time',
                },
                {
                  stt: 1,
                  transactionCode: 'transactionCode',
                  account: 'account',
                  teamLeader: 'teamLeader',
                  serviceType: 'serviceType',
                  customerCode: 'customerCode',
                  customerName: 'customerName',
                  month: 'month',
                  amount: 'amount',
                  payment: 'payment',
                  refund: 'refund',
                  status: 'status',
                  time: 'time',
                },
                {
                  stt: 1,
                  transactionCode: 'transactionCode',
                  account: 'account',
                  teamLeader: 'teamLeader',
                  serviceType: 'serviceType',
                  customerCode: 'customerCode',
                  customerName: 'customerName',
                  month: 'month',
                  amount: 'amount',
                  payment: 'payment',
                  refund: 'refund',
                  status: 'status',
                  time: 'time',
                },
                {
                  stt: 1,
                  transactionCode: 'transactionCode',
                  account: 'account',
                  teamLeader: 'teamLeader',
                  serviceType: 'serviceType',
                  customerCode: 'customerCode',
                  customerName: 'customerName',
                  month: 'month',
                  amount: 'amount',
                  payment: 'payment',
                  refund: 'refund',
                  status: 'status',
                  time: 'time',
                },
              ],
            };
          }}
          valueCheckbox={valueCheckbox}
        />
      </div>
    </div>
  );
};

export default ElectricBillOrderInfo;
